export default "__VITE_PUBLIC_ASSET__eff40930__"